import React, { useState } from 'react'
import './style.css'
import { Button, Modal } from 'react-bootstrap'

import Dan from '../../images/dan-armstrong.jpg'

function AboutDan() {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <section id="about">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="dan-img">
              <img className="img-fluid mb-4" src={Dan} alt="Dan" />
            </div>
          </div>
          <div className="col-md-8">
            <div className="right-content mx-5">
              <h6 className="section-title">ABOUT</h6>
              <h2 className="dan-name">Dan Armstrong</h2>
              <p className="section-p">
                I love my career and I'm 100% dedicated to getting the job done
                for you in the shortest amount of time with the highest return.
                I'm a problem solver with a "can-do" attitude and I'm always
                looking for creative ways to get your home sold! I view my
                business not as a single transaction, but rather as a means of
                growing relationships and an opportunity to serve. I look
                forward to extending my community of family and friends as I
                continue to grow my business.
              </p>
              {/*<div className="about-btn">
									<a
										id="calendly"
										className="button-red"
										href="https://calendly.com/dummy-calendly/armstrong-real-estate"
									>
										Want to Meet With Me?
									</a>
								</div>*/}
              <Button
                variant="primary"
                className="button-red"
                onClick={handleShow}
              >
                Want to Meet With Me?
              </Button>
              <Modal show={show} onHide={handleClose}>
                <iframe
                  src="https://calendly.com/armstrongrealestateco"
                  title="calendly"
                  width={800}
                  height={800}
                />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default AboutDan
